Vue.component('slideselect', {
    props: {   
        field: {
            type: String,            
        },
        fieldtitle: {
            type: String
        },  
        resultstring: {
            type: String
        },
        selectedkey: {
            type: String
        },
        items: {
            type: Array,
            required: false,
            default: () => {}
        },
    },
    data () {
        return {
            choice: "SELECTONE"
        }        
    },
    methods: {
        onChange () {
            let filtervalues = {
                field: this.field,
                selected: [this.choice],
                key: this.selectedkey
            }
            this.$emit('updatesearch', 'filters', filtervalues);

            
        }
    }
})